var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCouponMapWasteBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      cursor: "pointer",
      minWidth: 38
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14H13.1667H26.5",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8334 14.0001V25.6667C24.8334 26.1088 24.6578 26.5327 24.3453 26.8453C24.0327 27.1578 23.6088 27.3334 23.1667 27.3334H14.8334C14.3914 27.3334 13.9675 27.1578 13.6549 26.8453C13.3423 26.5327 13.1667 26.1088 13.1667 25.6667V14.0001M15.6667 14.0001V12.3334C15.6667 11.8914 15.8423 11.4675 16.1549 11.1549C16.4675 10.8423 16.8914 10.6667 17.3334 10.6667H20.6667C21.1088 10.6667 21.5327 10.8423 21.8453 11.1549C22.1578 11.4675 22.3334 11.8914 22.3334 12.3334V14.0001",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 18.1667V23.1667",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 18.1667V23.1667",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCouponMapWasteBasket);
export default __webpack_public_path__ + "static/media/icon_coupon_map_wasteBasket.4ae3a914da02b2a7ad5711ddb8fa1348.svg";
export { ForwardRef as ReactComponent };